/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  return (
    <>
      {currentUser?.decoded?.vendorName === 'Costa' && (
        <>
          <SidebarMenuItem
            to='/overview'
            title='Overview'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-chart-column'></i>
              </span>
            }
          />
          <SidebarMenuItem
            to='/costa-buy-box-dashboard'
            title='Buy Box Analysis'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-chart-column'></i>
              </span>
            }
          />
        </>
      )}

      <SidebarMenuItem
        to='/dashboard'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-chart-column'></i>
          </span>
        }
      />
      {currentUser?.decoded?.vendorName === 'Designer Eyes' && (
        <SidebarMenuItemWithSub
          to='#'
          title='Amazon Insights'
          customIconHtml={
            <span className='menu-icon'>
              <i className='fab fa-amazon'></i>
            </span>
          }
          dashboardsNeeded={['Amazon Dashboards/ Group']}
        >
          <SidebarMenuItem
            to='/all-amazon-sales'
            title='Sales Breakdown'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-chart-column'></i>
              </span>
            }
            dashboardsNeeded={['Amazon Dashboards/ Amazon Sales Breakdown']}
          />

          <SidebarMenuItem
            to='/amazon-sales-linechart'
            title='Sales Trend Analysis'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-chart-column'></i>
              </span>
            }
            dashboardsNeeded={['Amazon Dashboards/ Amazon Sales Trend Analysis']}
          />
          <SidebarMenuItem
            to='/amazon-brand-sales-linechart'
            title='Brand Trend Analysis'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-chart-column'></i>
              </span>
            }
            dashboardsNeeded={['Amazon Dashboards/ Amazon Brand Trend Analysis']}
          />
          <SidebarMenuItem
            to='/buy-box-dashboard'
            title='Buy Box Dashboard'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-chart-column'></i>
              </span>
            }
            dashboardsNeeded={['Amazon Dashboards/ Amazon Buy Box Dashboard']}
          />
          <SidebarMenuItem
            to='/apps/helium10-sales-uploader'
            title='Helium 10 Sales Dashboard'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-chart-pie'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
          />
          <SidebarMenuItem
            to='/apps/helium10-raw-uploader'
            title='Helium 10 Raw Data'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-database'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
          />
        </SidebarMenuItemWithSub>
      )}
      <SidebarMenuItem
        to='/products'
        title='Products'
        customIconHtml={
          <span className='menu-icon'>
            <i className='bi bi-sunglasses'></i>
          </span>
        }
        vendorNameNeeded={['Designer Eyes']}
        dashboardsNeeded={['Tools/ Products Table']}
      />
  <SidebarMenuItem
            to='apps/shipping-table'
            title='De Shipping'
            fontIcon='bi-app-indicator'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-truck'></i>
              </span>
            }
            dashboardsNeeded={['Designer Eyes/ DE Store Shipping']}
            vendorNameNeeded={['Designer Eyes']}
          />
      {/*################# PO Management #################*/}
      {(currentUser?.decoded?.vendorName === 'Valeria' ||
        currentUser?.decoded?.role === 'inventoryManagement') && (
        <SidebarMenuItemWithSub
          to='#'
          title='Purchase Orders'
          customIconHtml={
            <span className='menu-icon'>
              <i className='fa-solid fa-box'></i>
            </span>
          }
        >
          <SidebarMenuItem
            to='/purchase-orders/list'
            title='Customer Master List'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-users'></i>
              </span>
            }
          />
          <SidebarMenuItem
            to='/purchase-orders/main'
            title='Control Center'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-sliders-h'></i>
              </span>
            }
          />
          <SidebarMenuItem
            to='/purchase-orders/master'
            title='Master'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-crown'></i>
              </span>
            }
          />
          {/*
          <SidebarMenuItem
            to='purchase-orders/customer'
            title='Customer'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-chess-pawn'></i>
              </span>
            }
          />
          */}
          <SidebarMenuItem
            to='purchase-orders/orders'
            title='Customer Orders'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-chess-pawn'></i>
              </span>
            }
          />
        </SidebarMenuItemWithSub>
      )}
      {/*################# PO Management End #################*/}

      {/*################# Customer PO Management Start #################*/}

      <SidebarMenuItem
        to='purchase-orders/customer-view'
        title='Customer PO'
        roleNeeded={['customer']}
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-people-carry'></i>
          </span>
        }
      />
      {/*################# Customer PO Management End #################*/}

      {/* <SidebarMenuItem
        to='/consumer-metrics'
        title='Consumer Metrics'
        roleNeeded={['admin', 'vendor']}
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-people-group'></i>
          </span>
        }
        vendorNameNeeded={['Luxottica', 'Thelios']}
      /> */}

      <SidebarMenuItem
        to='/ai-forecasting'
        icon='chart-simple-2'
        title='AI Forecasting'
        fontIcon='bi-app-indicator'
        vendorNameNeeded={['Luxottica']}
      />

      {currentUser?.decoded?.vendorName === 'Designer Eyes' && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-uppercase fs-8 ls-1'>APPS</span>
          </div>
        </div>
      )}

      {/* <SidebarMenuItem
        to='apps/product-data-report'
        icon='chart-simple-2'
        title='Product Data Report'
        fontIcon='bi-app-indicator'
        vendorNameNeeded={['Designer Eyes']}
      /> */}
      {currentUser?.decoded?.vendorName === 'Designer Eyes' && (
        <>
          {/* @@@@@@@@@@@@@ Amazon tools START @@@@@@@@@@@@@@ */}
          <SidebarMenuItemWithSub
            to='#'
            title='Amazon Tools'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fab fa-amazon'></i>
              </span>
            }
            dashboardsNeeded={['Amazon Tools/ Group']}
          >
            
            {/* $$$$$$$$$ REPRICER START $$$$$$$$$ */}
            {/* Removing Repricer Not Needed At The Moment 
            <SidebarMenuItemWithSub
              to='#'
              title='Repricers'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fa-solid fa-tags'></i>
                </span>
              }
              dashboardsNeeded={['Amazon Tools/ Repricer']}
              vendorNameNeeded={['Designer Eyes']}
            >
              <SidebarMenuItem
                to='apps/repricer'
                title='EC-AMZ Repricer'
                customIconHtml={
                  <span className='menu-icon'>
                    <i className='fa-solid fa-tag'></i>
                  </span>
                }
                vendorNameNeeded={['Designer Eyes']}
              />
            </SidebarMenuItemWithSub>
            */}
            {/* $$$$$$$$$ REPRICER END $$$$$$$$$ */}
            <SidebarMenuItem
              to='apps/amazon-restocking'
              title='Restocking Calculator'
              fontIcon='bi-app-indicator'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fa-solid fa-boxes-packing'></i>
                </span>
              }
              vendorNameNeeded={['Designer Eyes']}
              dashboardsNeeded={['Amazon Tools/ Restocking Calculator']}
            />
            <SidebarMenuItem
              to='apps/buy-box-analysis'
              title='Buy Box Report'
              fontIcon='bi-app-indicator'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fab fa-amazon'></i>
                </span>
              }
              vendorNameNeeded={['Designer Eyes']}
              dashboardsNeeded={['Amazon Tools/ Buy Box Report']}
            />
            <SidebarMenuItem
              to='apps/invoice-processing'
              title='Invoice Processor'
              icon='update-file'
              vendorNameNeeded={['Designer Eyes']}
              dashboardsNeeded={['Amazon Tools/ Invoice Processor']}
            />
            <SidebarMenuItem
              to='apps/retail-readiness-report'
              icon='chart-simple-2'
              title='Retail Readiness Report'
              fontIcon='bi-app-indicator'
              vendorNameNeeded={['Designer Eyes']}
              dashboardsNeeded={['Amazon Tools/ Retail Readiness Report']}
            />
          </SidebarMenuItemWithSub>
        </>
      )}
      {/* @@@@@@@@@@@@@ Amazon tools END @@@@@@@@@@@@@@ */}

      {/* @@@@@@@@@@@@@ BETA APPS START @@@@@@@@@@@@@@ */}

      {/* ### POS Stores ### */}
      <>
        <SidebarMenuItemWithSub
          to='#'
          title='Stores'
          customIconHtml={
            <span className='menu-icon'>
              <i className='fa-solid fa-shop'></i>
            </span>
          }
          vendorNameNeeded={['Designer Eyes']}
          dashboardsNeeded={['Store Commissions']}
        >
          
          <SidebarMenuItem
            to='commissions'
            title='Comissions'
            fontIcon='bi-app-indicator'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-circle-dollar-to-slot'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
          />
          <SidebarMenuItem
            to='sales-associates'
            title='Sales Associates'
            fontIcon='bi-app-indicator'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-people-group'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
          />
          <SidebarMenuItem
            to='brand-tiers'
            title='Tiers'
            fontIcon='bi-app-indicator'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-ranking-star'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
          />
        </SidebarMenuItemWithSub>
      </>

      {/*################# Distribution Start #################*/}
      <SidebarMenuItemWithSub
        to='#'
        title='Distribution'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-building-circle-arrow-right'></i>
          </span>
        }
        vendorNameNeeded={['Thelios']}
      >
        {/* <SidebarMenuItem
          to='/distribution/caribbean'
          title='Caribbean'
          customIconHtml={<span className='menu-icon'>🇧🇶</span>}
          roleNeeded={['admin', 'vendor']}
        /> */}
        <SidebarMenuItem
          to='distribution/israel'
          title='Israel'
          customIconHtml={<span className='menu-icon'>🇮🇱</span>}
          roleNeeded={['admin', 'vendor']}
        />
      </SidebarMenuItemWithSub>
      {/*################# Distribtuion End #################*/}

      {(currentUser?.decoded?.vendorName === 'Thelios' ||
        currentUser?.decoded?.vendorName === 'Luxottica' ||
        currentUser?.decoded?.vendorName === 'Costa') && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-uppercase fs-8 ls-1'>Retail</span>
            </div>
          </div>

          <SidebarMenuItem
            to='/retail-performance'
            title='Brand Performance'
            customIconHtml={
              <span className='menu-icon text-blue'>
                <i className='fa fa-tags'></i>
              </span>
            }
            vendorNameNeeded={['Thelios']}
          />
          <SidebarMenuItem
            to='/inventory-insights'
            title='Inventory Insights'
            roleNeeded={['admin', 'vendor']}
            customIconHtml={
              <span className='menu-icon text-blue'>
                <i className='fa fa-tags'></i>
              </span>
            }
          />
        </>
      )}
      {currentUser?.decoded?.vendorName === 'Designer Eyes' ||
        (currentUser?.decoded?.vendorName === 'Costa' && (
          <SidebarMenuItemWithSub
            to='#'
            title='Business Intelligence'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-building-circle-arrow-right'></i>
              </span>
            }
            dashboardsNeeded={['Business Intelligence/ Group']}
          >
            <SidebarMenuItem
              to='/amz-brand-research'
              title='Brands Research'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fab fa-amazon'></i>
                </span>
              }
              vendorNameNeeded={['Luxottica', 'Designer Eyes']}
              dashboardsNeeded={['Business Intelligence/ Amazon Seller Research']}
            />
            <SidebarMenuItem
              to='/amz-seller-research'
              title='Seller Research'
              customIconHtml={
                <span className='menu-icon text-blue'>
                  <i className='fab fa-amazon'></i>
                </span>
              }
              vendorNameNeeded={['Luxottica', 'Designer Eyes']}
              dashboardsNeeded={['Business Intelligence/ Amazon Seller Research']}
            />
            {/*/////////////////// Amazon End ///////////////////////*/}

            {/*/////////////////// Amazon Costa Start ///////////////////////*/}
            {currentUser?.decoded?.vendorName === 'Costa' && (
              <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                  <span className='menu-section text-uppercase fs-8 ls-1'>
                    Business Intelligence
                  </span>
                </div>
              </div>
            )}
            <SidebarMenuItem
              to='/brands/costa'
              title='Product Research'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fab fa-amazon'></i>
                </span>
              }
              vendorNameNeeded={['Costa']}
            />
            <SidebarMenuItem
              to='/sellers/costa'
              title='Seller Research'
              customIconHtml={
                <span className='menu-icon text-blue'>
                  <i className='fab fa-amazon'></i>
                </span>
              }
              vendorNameNeeded={['Costa']}
            />
            {/*/////////////////// Amazon Costa End ///////////////////////*/}
          </SidebarMenuItemWithSub>
        ))}
      {/* ################# Resources Start #################
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-uppercase fs-8 ls-1'>Resources</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/catalog'
        icon='update-file'
        title={intl.formatMessage({id: 'MENU.CATALOG'})}
        fontIcon='bi-app-indicator'
        roleNeeded={['admin', 'vendor']}
      />
      <SidebarMenuItem
        to='/image-upload'
        icon='update-file'
        title='Image Upload'
        fontIcon='bi-app-indicator'
        roleNeeded={['admin']}
      />

      <SidebarMenuItem
        to='/changelog'
        title='Updates'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-clock-rotate-left'></i>
          </span>
        }
      /> */}

      <>
        <SidebarMenuItemWithSub
          to='#'
          title='BETA APPS'
          customIconHtml={
            <span className='menu-icon'>
              <i className='fa-solid fa-flask'></i>
            </span>
          }
          vendorNameNeeded={['Designer Eyes']}
          dashboardsNeeded={['Beta Apps/ Group']}
        >
          <SidebarMenuItem
            to='inventory'
            title='Inventory(BETA)'
            fontIcon='bi-app-indicator'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fab fa-amazon'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
          />

          <SidebarMenuItem
            to='apps/amz-product-analysis'
            title='Product Analyzer(BETA)'
            fontIcon='bi-app-indicator'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fab fa-amazon'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
          />

          {/* <SidebarMenuItem
              to='apps/buy-box-protect'
              title='Buy Box Protect(BETA)'
              fontIcon='bi-app-indicator'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fab fa-amazon'></i>
                </span>
              }
              vendorNameNeeded={['Designer Eyes']}
            /> */}
          <SidebarMenuItem
            to='apps/amz-masterfile-generator'
            title='Masterfile Generator(BETA)'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fab fa-amazon'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
          />
          <SidebarMenuItem
            to='apps/map-violations'
            title='Map Violation Checker'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fab fa-amazon'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
          />
        </SidebarMenuItemWithSub>
        <SidebarMenuItemWithSub
          to='#'
          title='Data Tools'
          customIconHtml={
            <span className='menu-icon'>
              <i className='fa-solid fa-database'></i>
            </span>
          }
          vendorNameNeeded={['Designer Eyes']}
          dashboardsNeeded={['Data Tools/ Group']}
        >
          <SidebarMenuItemWithSub
            to='#'
            title='Image Tools'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-images'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
            dashboardsNeeded={['Data Tools/ Image Tools']}
          >
            <SidebarMenuItem
              to='apps/product-images/'
              title='Product Images Fetcher'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fa-solid fa-image'></i>
                </span>
              }
              vendorNameNeeded={['Designer Eyes']}
            />

            <SidebarMenuItem
              to='apps/product-images-uploader/'
              title='Product Images Uploader'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fa-solid fa-upload'></i>
                </span>
              }
              vendorNameNeeded={['Designer Eyes']}
            />

            <SidebarMenuItem
              to='apps/image-reviewer/'
              title='Product Images Reviewer'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fa-solid fa-magnifying-glass'></i>
                </span>
              }
              vendorNameNeeded={['Designer Eyes']}
            />
            {/* <SidebarMenuItem
              to='apps/map-price-rebate-analysis'
              title='MAP Price Rebate Analysis'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fas fa-tags'></i>
                </span>
              }
              vendorNameNeeded={['Designer Eyes']}
            /> */}
          </SidebarMenuItemWithSub>
          <SidebarMenuItem
            to='apps/info-product-analysis'
            title='Product Info Analysis'
            fontIcon='bi-app-indicator'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa fa-chart-line'></i>
              </span>
            }
            vendorNameNeeded={['Designer Eyes']}
            dashboardsNeeded={['Data Tools/ Product Data Analyzer']}
          />
          <SidebarMenuItem
            to='/logs'
            title='ETL Logs'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-file-circle-minus'></i>
              </span>
            }
            dashboardsNeeded={['Data Tools/ ETL Logs']}
          />
          <SidebarMenuItem
            to='/data-reformatter'
            title='Data Reformatter'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-arrows-rotate'></i>
              </span>
            }
            dashboardsNeeded={['Data Tools/ ETL Logs']}
          />
        </SidebarMenuItemWithSub>
        {currentUser?.decoded?.role === 'admin' && (
          <>
            <div className='menu-item mt-5' style={{borderTop: '1px solid dark-grey'}}>
              <div className='menu-content pb-2'>
                <span className='menu-section text-uppercase fs-8 ls-1'>Admin Center</span>
              </div>
            </div>
            <SidebarMenuItem
              to='/user-management'
              title='Users'
              customIconHtml={
                <span className='menu-icon'>
                  <i className='fa-solid fa-crown'></i>
                </span>
              }
              roleNeeded={['admin']}
            />
            
            {/* Hidden Audio Control - Lucas Only - Secret clickable area */}
            {currentUser?.decoded?.email === 'lucas@designereyes.com' && (
              <div style={{
                opacity: 0,
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = '0.1';
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                e.currentTarget.style.cursor = 'pointer';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = '0';
                e.currentTarget.style.backgroundColor = 'transparent';
              }}>
                <SidebarMenuItem
                  to='soundboard'
                  title='Audio Control'
                  customIconHtml={
                    <span className='menu-icon' style={{
                      opacity: 0
                    }}>
                      <i className='fa-solid fa-volume-up'></i>
                    </span>
                  }
                />
              </div>
            )}
          </>
        )}
      </>
    </>
  )
}

export {SidebarMenuMain}
